import { Card, CardContent } from "@/components/ui/card";
import { useTranslation } from "react-i18next";
import type { KpiCardsProps } from "./types";
import { calculateKpiData, generateKpiItems } from "./utils";

export function KpiCards({ opportunities, leads = [] }: KpiCardsProps) {
  const { t } = useTranslation();

  const kpiData = calculateKpiData(opportunities, leads);
  const kpiItems = generateKpiItems(kpiData, t);

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 ">
      {kpiItems.map((kpi, index) => {
        const Icon = kpi.icon;
        return (
          <Card key={index} className="bg-card border hover:shadow-md border-primary/50 shadow-sm">
            <CardContent className="p-6">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm font-medium text-muted-foreground mb-1">{kpi.title}</p>
                  <p className="text-3xl font-bold text-foreground">{kpi.value}</p>
                </div>
                <div className={`p-3 rounded-full ${kpi.gradient} hover:scale-110 `}>
                  <Icon className="h-6 w-6 text-white" />
                </div>
              </div>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
}
